import React from 'react';
import { Layout, Button, Tabs, Radio, Modal, Spin, Select, Tree, Dropdown, Icon, Menu, Tooltip } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { SvgIconText } from 'freesia-ui';

import "./Crumbar.less";

export default class Crumbar extends React.Component {

    state = {
    };

    componentWillMount() {

    }

    componentWillUnmount() {

    }

    componentDidMount() {
        this.props.onNavigateTo("root");
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.items !== nextProps.items;
    }

    navigateTo(item) {
        this.props.onNavigateTo(item);
    }

    renderItems() {

        return this.props.items.map((c, i) => {

            return [
                <RightOutlined type="right" key={`${i}.arrow`} className="bar-arrow" style={this.props.arrowStyle} />,
                <Button key={i}
                    className={'btn-bd-focus-none btn-pd-sm btn-bk-hover btn-bd-none bar-btn ' + (i === this.props.items.length - 1 ? "primary-text" : "")}
                    onClick={e => this.navigateTo(c)}
                    style={{ padding: '3px 5px 1px 5px' }}>
                    {c.icon ? <SvgIconText spacing='' type={c.icon} text={c.name} /> : <div>{c.name}</div>}
                </Button>
            ];
        });
    }

    render() {

        return (
            <div className={"layout-h crumbstylebar bd-bottom" + (this.props.className || "")} style={this.props.style} >
                <Tooltip title={this.props.rootTooltip || "Root"}>
                    <Button
                        className='btn-bd-focus-none btn-pd-sm btn-bk-hover btn-bd-none bar-btn'
                        onClick={e => this.navigateTo("root")}
                        style={{ padding: '1px 5px' }}>
                        <SvgIconText spacing='' type='#anticon-folder4' text={this.props.showRootText ? (this.props.rootTooltip || "Root") : ""} />
                    </Button>
                </Tooltip>
                {this.renderItems()}
            </div >
        );
    }
}
